import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const isDocumentModeResolver: FieldResolver = (metadata: Metadata) =>
  ({ isDocumentMode: metadata.isDocumentMode() } as StreamData)

export default isDocumentModeResolver
